import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useWithdrawals = (page = 1) => useQuery({ queryKey: [`withdrawals`, page], queryFn: async () => {
    const callback = await API.get(`/withdrawals?page=${page}`)
    return callback?.data
}, staleTime: 60000, gcTime: 1000 * 60 * 30 })

export default useWithdrawals